import { IPlaceSchedule } from "@common/redux/types/places";
import moment from "moment";

const formatHours = (time) => moment.utc(time).format('HH:mm');

export const getWorkingHours = (schedule: IPlaceSchedule): string => {
  const dayOfTheWeek = moment().isoWeekday()

  const scheduleArray = Object.keys(schedule).map(function (key) {
    return { type: key, name: schedule[key] };
  });
  const isScheduleFilled = scheduleArray.filter(day => day.name.length > 0).length > 0

  if (!isScheduleFilled) return "Круглосуточно"
  if (schedule[dayOfTheWeek].length > 0
    && schedule[dayOfTheWeek][0]
    && schedule[dayOfTheWeek][0].to) {
    return `Сегодня: ${formatHours(schedule[dayOfTheWeek][0].from)}-${formatHours(schedule[dayOfTheWeek][0].to)}`
  }

  return 'Закрыто'
}
